// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e766464","511":"fdf81a31","842":"d852f36f","927":"6504e57f"}[chunkId] + ".chunk.js";
};